import React, { Component } from 'react';
// import EventSlider from "./common/EventSlider";
import GuestLoginFrom from './Auth/GuestLoginForm';
import { Drawer } from 'antd';
import Logo from './common/Logo';
// import SEO from './SEO'
class GuestLogin extends Component {
  render() {
    return (
      <>
        <div className="adma-login-wrap">
          <div className="adma-login-container">
            <div className="loginpage">
              <div className="adma-login-main-content">
                <div className="adma-app-login-content guestLoginBox">
                  <div className="adma-logo-content-bg">
                    <h1>
                      <img src={require('../assets/img/login/logo.png')} />
                    </h1>
                    <h2 className="login-title">
                      Sign In <span>to your account</span>
                    </h2>
                  </div>
                  <GuestLoginFrom />
                </div>
              </div>
              <div className="login-right-section">
                <div className="media">
                  <div className="media-left">
                    <img src={require('../assets/svg/Login/price-guarantee.svg')} alt="price-guarantee" />
                  </div>
                  <div className="media-body">
                    <h3 className="serives-name">News & Events</h3>
                    <p>Contrary to popular belief, Lorem Ipsum is not simply random text.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="h-full">
        <div className="login-container h-full d-flex width-full">
          <GuestLoginFrom />
          <div className="event-block h-full">
            <div className="login-logo text-center">
              <div className="login-brand mb-15">
                <Logo />
              </div>
              <div className="login-brand-name white-text">
                Welcome to P N Shah.
              </div>
            </div>
            <div className="event-slider">
              <div className="slider-wrap">
                <div className="slider">
                  <div className="slide">
                    <EventSlider />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div> */}
      </>
    );
  }
}

export default GuestLogin;
